import { Stack } from '@adc/parallax-component-library';

import { ThemedImage } from '../ThemedImage';

type Props = { isMobileBrowser?: boolean };

function AppLogo({ isMobileBrowser = false }: Props) {
  return (
    <Stack padding={isMobileBrowser ? '$4' : 40}>
      <ThemedImage
        resourceKey="Global.microcopy.common.libreLogoLight"
        alt=""
        id="Global.microcopy.common.libreLogo"
        style={{
          height: isMobileBrowser ? '32px' : '52px',
          objectFit: 'contain',
        }}
      />
    </Stack>
  );
}

export { AppLogo };
